import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BaseComponent } from '@ex/module/core/domain/base-component';
import { EssentialObject } from '@ex/module/core/services/essential-object.service';
import { DATA_TOKEN, ICDKPortalComponent } from '@ex/module/shared/Theme/services/zen-cdk.service';
import { GlobalCriteria, GlobalFilterSection } from '../../data-access/models/models';
import { Hierarchy } from '@ex/module/core/data-models/hierarchy';
import { NgForm } from '@angular/forms';
import { GlobalFiltersHelperService } from '../../data-access/services/global-filters-helper.service';
import { debounceTime, pairwise, startWith, } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'global-filters',
  templateUrl: './global-filters.component.html',
  styleUrls: ['./global-filters.component.scss']
})
export class GlobalFiltersComponent extends BaseComponent implements ICDKPortalComponent, AfterViewInit {
  @ViewChild('form') ngForm: NgForm;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() results: EventEmitter<any> = new EventEmitter();
  language: string = "EN";
  filters: GlobalFilterSection[] = [];
  treeList$: Observable<Hierarchy>;
  stringifiedFilters: string = '[]';
  count: number = 0;
  private activatedCriteria!: string;
  hideCount: boolean = false;
  constructor(@Inject(DATA_TOKEN) public data: { essentialObject: EssentialObject, SurveyType?: string, SurveyKey?: string, service?: any, count?: number, module?: boolean, template: TemplateRef<any> }, private globalFilterHelper: GlobalFiltersHelperService) {
    super();
  }
  ngAfterViewInit(): void {
    this.addSubscription(
      this.globalFilterHelper.getFilterCounts(
        this.data.essentialObject,
        this.data.SurveyKey,
        this.data.SurveyType ?? '',
        this.data.service,
        this.data.module
      ).subscribe());

    this.addSubscription(
      this.ngForm.form.valueChanges.pipe(
        debounceTime(200),
        startWith(this.ngForm.form.value),
        pairwise()
      ).subscribe(([oldValue, newValue]) => {
        const nonEmptyNewKeys = Object.keys(newValue).filter(key => {
          const val = newValue[key];
          return val !== null && val !== undefined && val !== '' && val?.length > 0;
        });
        if (this.globalFilterHelper.selectedTreeEntities$.value.length > 0 && nonEmptyNewKeys.length)
          this.globalFilterHelper.resetTree();

        // Proceed only if more than 2 fields in newValue are filled
        if (nonEmptyNewKeys.length >= 2) {
          const commonValue = nonEmptyNewKeys.find(key =>
            oldValue.hasOwnProperty(key) && oldValue[key] === newValue[key]
          );
          console.log('Common unchanged values:', commonValue);

          this.filters.forEach(filter => {
            filter.criteria.forEach(f => {
              if (f.key == commonValue || !commonValue)
                f.value = []
            })
          })
        }
        setTimeout(() => {

          this.globalFilterHelper.filters$.next(this.filters);
        }, 200);
      })
    );


  }

  ngOnInit() {
    this.count = this.globalFilterHelper.count;
    this.hideCount = !(!!this.data.service);

    this.language = this.data.essentialObject.language;
    const filters$ = this.globalFilterHelper.filters$.subscribe(filters => {
      this.filters = filters;
      const activeCriteria = this.filters.flatMap(x => x.criteria).find(c => !!(c.value?.length))?.key;
      if (!activeCriteria && !this.activatedCriteria)
        this.activatedCriteria = 'tree';
      else if (activeCriteria && !this.activatedCriteria)
        this.activatedCriteria = activeCriteria;

    });
    this.addSubscription(filters$);
    this.treeList$ = this.globalFilterHelper.treeList$.pipe(debounceTime(200));
    this.globalFilterHelper.applyFilters$.next(false);
  }
  apply(form: NgForm) {
    this.globalFilterHelper.applyFilters$.next(true);

    setTimeout(() => {
      
      this.results.emit(this.globalFilterHelper.requestedFilters$.value);
    }, 200);
  }

  resetAll() {
    this.globalFilterHelper.resetAllFilters();
  }

  closeDrawer(open: boolean) {
    if (!open)
      this.close.emit(true);
  }

  checkRow(row: Hierarchy) {
    if (!!this.filters?.find(x => x.criteria?.find(y => y.value?.length)))
      this.globalFilterHelper.removeFilters();
    setTimeout(() => {
      this.globalFilterHelper.handleTreeClick(row);
    }, 200);
  }


  setActivatedCriteria(criteriaKey: string) {
    this.activatedCriteria = criteriaKey;

  }

  hasCount(criteria: GlobalCriteria[]) {
    return criteria.some(x => !!x['count'])
  }
}
